import api from './api';

export const jobService = {
  getPublicJobs: () => api.get('/jobs'),
  getJobByKey: (key) => api.get(`/jobs/${key}`),
  getAllJobsAdmin: () => api.get('/jobs/admin/all'),
  createJob: (data) => api.post('/jobs', data),
  updateJob: (id, data) => api.put(`/jobs/${id}`, data),
  deleteJob: (id) => api.delete(`/jobs/${id}`),
  reorderJobs: (orders) => api.post('/jobs/reorder', { orders }),
  getDepartmentOrder: () => api.get('/jobs/department-order'),
  updateDepartmentOrder: (order) => api.put('/jobs/department-order', { order })
};
